import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {dataToolSchemas} from '../../utils/schemas';

const toolName = 'get-cms-collection-item-details' as const;

const argumentZod = z.object({
  collectionId: dataToolSchemas.collectionId,
  itemId: dataToolSchemas.itemId,
  cmsLocaleId: dataToolSchemas.localeId.optional(),
});

export const getCMSCollectionItemDetailsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get CMS collection item details',
  family: 'cms',
  llmTool: {
    name: toolName,
    description:
      'Gets the detailed information of a specific item in a CMS collection. Returns complete item data including field values, metadata, timestamps, and publication status.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [
    {
      resource: 'SiteCollection',
      action: 'read',
      resolveResources: (args) => [
        {type: 'SiteCollection', id: args.collectionId},
      ],
    },
  ],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});

export type GetCMSCollectionItemDetailsArgumentType = z.infer<
  typeof argumentZod
>;
